<app-courrier-fiche-form (newMailActive)="receiveNewMail($event)"></app-courrier-fiche-form>
